import chimeUrl from './notification-chime.mp3';

/** 2days 알림음 — notification-chime.mp3 를 한 번 울린다 (Lead inbox · 워크보드 공통) */

export const SOUND_KEY = 'td-sound';
const DEFAULT_SOUND = { on: true, volume: 100 };

export const loadSound = () => {
  try {
    const saved = JSON.parse(window.localStorage.getItem(SOUND_KEY) ?? 'null');
    const volume = Number(saved?.volume);
    return {
      on: saved?.on !== false,
      volume: Number.isFinite(volume) ? Math.min(100, Math.max(0, volume)) : DEFAULT_SOUND.volume,
    };
  } catch {
    return DEFAULT_SOUND;
  }
};

export const saveSound = (sound) => {
  try {
    window.localStorage.setItem(SOUND_KEY, JSON.stringify(sound));
  } catch {
    // 저장이 막혀도 이번 화면에서는 바꾼 값으로 둔다
  }
};

let audio = null;
let sample = null;

const context = () => {
  if (audio) return audio;
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  try {
    audio = new Ctx();
  } catch {
    audio = null;
  }
  return audio;
};

const load = (ac) => {
  if (!sample) {
    sample = fetch(chimeUrl)
      .then((res) => res.arrayBuffer())
      .then((data) => ac.decodeAudioData(data))
      .catch(() => {
        sample = null;
        return null;
      });
  }
  return sample;
};

/** 한 번 울린다. 자동재생이 막혀 있으면(suspended) 아무것도 하지 않는다 */
const beep = () => {
  const { on, volume } = loadSound();
  if (!on || volume <= 0) return;
  const ac = context();
  if (!ac || ac.state !== 'running') return;
  load(ac).then((buffer) => {
    if (!buffer) return;
    const source = ac.createBufferSource();
    source.buffer = buffer;
    const gain = ac.createGain();
    gain.gain.value = (volume / 100) ** 2;
    source.connect(gain);
    gain.connect(ac.destination);
    source.start();
  });
};

const GESTURES = ['pointerdown', 'keydown'];
let waiting = false;

/** 한 번 울린다. 자동재생이 막혀 있으면 첫 클릭·키 입력 때 한 번 울린다 (오류 없음) */
export const chime = () => {
  const ac = context();
  if (!ac) return;
  if (ac.state === 'running') {
    beep();
    return;
  }
  if (waiting) return;
  waiting = true;
  const play = () => {
    if (!waiting) return;
    waiting = false;
    GESTURES.forEach((e) => window.removeEventListener(e, onGesture, true));
    beep();
  };
  const onGesture = () => {
    ac.resume()
      .then(play)
      .catch(() => {});
  };
  ac.resume()
    .then(() => ac.state === 'running' && play())
    .catch(() => {});
  GESTURES.forEach((e) => window.addEventListener(e, onGesture, true));
};
